import React from 'react';
import ListItem from '@liquidweb-dev/undercurrent/ListItem';
import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';
import Wrapper from './Wrapper';

interface LoadingProps {
	header: React.ReactNode;
}

const Loading = ({ header }: LoadingProps) => (
	<Wrapper>
		{header}
		<ListItem>
			<Skeleton variant="rounded" width="100%" />
		</ListItem>
		<ListItem>
			<Skeleton variant="rounded" width="100%" />
		</ListItem>
		<ListItem>
			<Skeleton variant="rounded" width="100%" />
		</ListItem>
	</Wrapper>
);

export default Loading;
